import { CreationStatus } from '@zorro/clients';
import { useMonolithQuery } from '@zorro/web/ui-utils';

export function useZorroPayActivationStatus({
  employeeId,
  enabled,
}: {
  employeeId: string;
  enabled: boolean;
}) {
  const { data: employeeAccountStatus } = useMonolithQuery({
    method: 'paymentsControllerGetEmployeePaymentsAccountStatus',
    params: [employeeId],
    enabled,
  });

  return {
    employeeAccountStatus,
    isActivated:
      employeeAccountStatus?.accountStatus === CreationStatus.ACTIVATED,
  };
}
